module.exports = __webpack_public_path__ + "front/img/yqh02.4e42ea44.png";